import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

const { Option } = Select;

const Filter = ({
  onChange,
  placeholder,
  defaultKeys = [],
  filterValues = [],
}) => {
  const [keys, setKeys] = useState(filterValues);

  useEffect(() => {
    if (filterValues) {
      setKeys(filterValues);
    }
  }, [filterValues]);

  const handleChange = (newKeys) => {
    setKeys(newKeys);
    onChange?.(newKeys);
  };

  return (
    <Select
      mode="multiple"
      showArrow
      value={keys}
      style={{ width: '100%' }}
      placeholder={placeholder}
      onChange={handleChange}
    >
      {defaultKeys.map((key) => (
        <Option key={key}>{key}</Option>
      ))}
    </Select>
  );
};

Filter.propTypes = {
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  defaultKeys: PropTypes.array,
  filterValues: PropTypes.array,
};

Filter.defaultProps = {
  defaultKeys: [],
  filterValues: [],
};

export default Filter;
